import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Col, Row, Button } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class ComercioExteriorMercanciaDescripcionesEspecificasForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        isValid: true,
      });
    }
  }

  rules(data) {
    return {
      'Marca': ['required', 'string', 'min:1', 'max:35'],
      'Modelo': ['string', 'min:1', 'max:80'],
      'SubModelo': ['string', 'min:1', 'max:50'],
      'NumeroSerie': ['string', 'min:1', 'max:40'],
    }
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    this.notifyFormDataChange(data);
  }

  notifyFormDataChange = (data) => {
    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      descripciones_especificas: false,
      data: {}
    })
  }

  render() {
    const { isValid, data } = this.state;
    const rules = this.rules(data);

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Marca"
              name="Marca"
              placeholder=""
              help=""
              minLength="1"
              maxLength="35"
              rules={ rules.Marca }
              value={ data.Marca }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Modelo"
              name="Modelo"
              placeholder=""
              help=""
              minLength="1"
              maxLength="80"
              rules={ rules.Modelo }
              value={ data.Modelo }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="SubModelo"
              name="SubModelo"
              placeholder=""
              help=""
              minLength="1"
              maxLength="50"
              rules={ rules.SubModelo }
              value={ data.SubModelo }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Número de Serie"
              name="NumeroSerie"
              placeholder=""
              help=""
              minLength="1"
              maxLength="40"
              rules={ rules.NumeroSerie }
              value={ data.NumeroSerie }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row className="pt-3">
          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar Descripción
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

export default ComercioExteriorMercanciaDescripcionesEspecificasForm;